<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <div class="qr-code">
    <a
      v-if="invoice"
      v-bind="this.$browserDetect.isFirefox ? { target: '_blank'} : {}"
      @click="$emit('qr-code-tapped')"
    >
      <lnbig-qr-code
        v-if="invoice"
        :value="`lightning:${invoice}`.toUpperCase()"
        :level="levelQrCode"
        :size="sizeQrCode"
        :class="{ 'qr-code-blur': prepaid || error || currentCountdown === 0, 'qr-code-block': true }"
      />
    </a>
    <v-dialog
      v-model="warningReturn"
      :width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Don't forget to come back here
        </v-card-title>

        <v-card-text class="my-3">
          Your wallet will open now. Please switch back to the browser after sending the payment and continue the following steps!
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="warningReturn = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="openWallet"
          >
            OK, I'll be back
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-avatar
      v-if="prepaid && ! error"
      class="progress"
      color="green"
      :size="50"
    >
      <v-icon
        color="white"
        :size="30"
      >
        done
      </v-icon>
    </v-avatar>
    <v-avatar
      v-else-if="error"
      class="progress"
      color="red"
      :size="50"
    >
      <v-icon
        color="white"
        :size="30"
      >
        error_outline
      </v-icon>
    </v-avatar>
  </div>
</template>

<script>/**
 * TODO Подумать - где размещать сообщение об ошибке
 */
import QrCode from "@/components/Mixin/QrCode"
import Countdown from "@/components/Mixin/Countdown"

export default {
  name: "Prepayment",
  mixins: [QrCode, Countdown],
  props: {
    invoice: String,
    prepaid: Boolean,
    error: String,
  },
  mounted() {
    this.startCountdown()
  },
  computed: {
    startTimeForCountdown() { return this.$store.state.openChannel.startTimeForPrepaymentCountdown }
  },
}
</script>

<style scoped>
.qr-code {
  display: block;
  position: relative;
  text-align: center;
}
.qr-code-blur {
  opacity: 0.3;
}
.qr-code-block {
  display: inline-block;
}
.progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
